/*
 * Copyright (c) 2020. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

import { NotificationModel } from './notification.model';

export class MyNotificationModel {
  notificationId?: string;
  userId?: string;
  notificationDetails: NotificationModel;

  constructor(notificationId?: string, userId?: string, notificationDetails?: NotificationModel) {
    this.notificationId = notificationId;
    this.userId = userId;
    this.notificationDetails = notificationDetails;
  }

  toJson(): Object {
    const object = {
      notification_id: this.notificationId,
      user_id: this.userId,
      notification_details: this.notificationDetails.toJson(),
    };
    Object.keys(object).forEach(
      (k) =>
        !object[k] && typeof object[k] !== 'boolean' && object[k] !== undefined && delete object[k]
    );
    return object;
  }

  fromJson(input: any): MyNotificationModel {
    const notificationDetail = new NotificationModel();
    return new MyNotificationModel(
      input['notification_id'],
      input['user_id'],
      notificationDetail.fromJson(input['notification_details'])
    );
  }
}
